var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.uniqueKey,staticClass:"rich-wrapper",style:(_vm.showRichRootStyle)},[_c('div',{ref:"editable",staticClass:"rich-show-inner",style:(_vm.showRichTextStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }